// src/locales/en.ts

import settings from '../English/en.settings';
import sidebars from '../English/en.sidebars';
import chat from '../English/en.chat';
import myProfile from '../English/en.myProfile';    
import ad from '../English/en.ad';
import termsOfUse from '../English/en.termsOfUse';
import privacyPolicy from './en.privacyPolicy';
import accountSupport from './en.accountSupport';
import platformGuide from './en.platformGuide';
import advertisementGuide from './en.advertisementGuide';
import faq from './en.faq';

import home from './en.home';
import help from './en.help';
import countries from './en.countries'

// Top-level auth & common strings
const en = {
    // 🔒 ForgotPassword.tsx
    enterYourEmail: "Enter your email",
    sendResetLink: "Send password reset link",
    pleaseEnterEmail: "❌ Please enter your email.",
    couldNotSendResetEmail: "❌ Could not send reset email. Try again.",
  
    // 🌟 Start page / login
    slogan: "Let's get the party started",

  email: "Email",
  password: "Password",
  login: "Login",
  loginElnydo: "Log in",
  createAccount: "Create new account",
  forgotPassword: "Forgot Password?",
  legalNoticeforgotpassword: "By continuing, you agree to our policies.",


  startPage: {
    loginSuccess: "✅ Login successful!",
    invalidCredentials: "❌ Invalid login credentials!",
    privacyTerms: "Privacy & Terms",
    legalNoticelogin: "By logging in, you agree to our policies.",
    loginTitlelogin: "Log in",
    loginTitlehappening: "to see what's happening around you.",

  },

  twoFA: {
    title: "Enter the 6-digit code",
    intro: "We emailed a login verification code to you.",
    placeholder: "••••••",
    cancel: "Cancel",
    verify: "Verify & Continue",
    verifying: "Verifying…",
    hint: "Didn’t get it? It can take a minute. Also check spam.",
    missingToken: "Missing 2FA token",
    invalidCode: "Enter the 6-digit code we sent.",
    verifyFailed: "Verification failed.",
    requestFailed: "Could not send verification code.",
  },     
  
    // 👤 Profile setup / signup
    profileSetup: {
      title: "Create your account",
      profileName: "Profile Name",
      email: "Email",
      emailplace: "name@example.com",
      password: "Password",
      createpassword: "Create a Password (at least 8 characters and at least 1 number)",
      over18: "I confirm that I am over 18 years old",
      createProfile: "Create Account",
      alreadyAccount: "Already have an account? Log in",
      legalNotice: "By creating an account, you agree to our policies.",
      privacyPolicy: "Privacy Policy",
      termsOfUse: "Terms of Use",
    },
  
    // 🔁 Reset password flow
    resetPassword: {
      title: "Reset Your Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm New Password",
      resetting: "Resetting...",
      resetButton: "Reset Password",
      passwordsMismatch: "Passwords do not match!",
      resetError: "❌ Error resetting password.",
      success: "✅ Password reset successful! Logging you in...",
    },
  
    // ✉️ Confirm email (email content + screen copy)
    confirmEmail: {
      title: "Check your email to confirm",
      subtitle: "We've sent a confirmation email to:",
      note: "Please check your inbox and spam folder.",
      returnButton: "Back to login",
      heading: "Welcome to Elnydo 🎉",
      intro: "Click the button below to confirm your email and activate your profile:",
      button: "Confirm Email",
      footer1: "This link is valid for 24 hours for your security.",
      footer2: "If you did not create this account, simply ignore this message.",
      footer3: "This email was sent to you by Elnydo.",
    },
  
    // 📩 “Check your email” screen
    checkEmail: {
      title: "Confirm Your Email",
      subtitle: "We've sent a confirmation link to:",
      note: "Please check your inbox (and spam folder) to complete registration.",
      returnButton: "Return to Login",
    },
  
    // 📤 “Reset link sent” screen
    emailSentTitle: "Check Your Email",
    emailSentSubtitle: "We've sent a password reset link to:",
    emailSentNote: "Please check your inbox (and spam folder).",
    emailSentReturnButton: "Return to Start Page",
  
    // 🌐 Language
    language: "Language",
    
   common: {
  back: "Back",
  continue: "Continue",
  close: "Close",
  cancel: "Cancel",
  yes: "Yes",
  no: "No",
  confirm: "Confirm",
  ok: "OK",
  saving: "Saving...",
},

/////////////////////////////////////////////////////////////  
// GalleryPosting 
/////////////////////////////////////////////////////////////  
    
  galleryPosting: {
    overlay: {
      uploading: "Uploading",
    },

    alerts: {
      videosSkippedInvalidDuration: "Some videos were skipped because they must be between 2.9 seconds and 183 seconds.",
      onlyOneVideoAllowed: "Only one video is allowed per post.",
      videoMustBeFirst: "Video must be the first media item.",
      mediaPerPostLimit: "You can add up to 8 media per post. Remove something before adding more.",
      mediaPerPostHardLimit: "You can only have up to 8 media in a single post.",
      videosSkippedTooLongShort: "We skipped video(s) longer than 3 minutes and 3 seconds.",
      videosSkippedTooLongSummary: "Some videos were skipped because they are longer than 3 minutes and 3 seconds.",
      filesSkippedByCapSummary: "Some files were skipped because you hit the limit of 8 media per post.",
      loginRequired: "You need to Login.",
      hashtagLimit: "You can add up to {{max}} hashtags.",
      postTooLargeClient: "This post is too large ({{actualGb}} GB). The maximum allowed per post is about {{maxGb}} GB.\n\nPlease remove some videos or shorten them before posting.",
      postTooLargeServer: "Your post is too large. The maximum total media size per post is about {{maxGb}} GB.\n\nPlease remove some media or shorten your videos.",
      dailyPostLimitReached: "You have reached your daily posting limit. Try again tomorrow.",
      vpnBlockedFallback: "Media uploads are not allowed while using a VPN or proxy. Please disable it and try again.",
      postFailed: "Failed to post media.",
      discardConfirm: "Are you sure you want to discard changes?",
    },

    banner: {
      vpnBlocked: "Media uploads are not allowed while using a VPN or proxy. Please disable it and try again.",
    },

    buttons: {
      delete: "Delete",
      filter: "🎛️ Filter",
      music: "🎵 Music",
      changeMusic: "🎵 Change Music",
      addMusic: "Add Music",
    },

    fallback: {
      noPreview: "No preview available",
      anonymous: "Anonymous",
    },

    addMedia: {
      title: "Click here to choose Images & Videos",
      subtitle: "…or drop them here",
    },

    addButtons: {
      add: "Add",
      change: "Change",
      filter: "Filter",
      },
  },

/////////////////////////////////////////////////////////////  
// Gallery....
/////////////////////////////////////////////////////////////

    gallery: {
      noPostsForFilter: "No posts available for the selected filter.",
      unknownUser: "Unknown User",
      unknownLocation: "Unknown",

      post: {
        unknownUser: "Unknown user",
        noMedia: "No media available",
        postedAt: "posted at {{date}}",
        presentationButton: "Presentation",
      },
      
      edit: {
        missingPostId: "Missing post id",
        saveFailed: "Failed to save changes.",
        discardConfirm: "Discard all changes?",
        saving: "Saving",
        anonymous: "Anonymous",
        noPreview: "No preview available",
        delete: "Delete",
        title: "Change your Post",
        confirmSaveTitle: "Save changes to this post?",
        confirmSaveSubtitle: "This will overwrite your current post.",
        updatedTitle: "Post updated",
        updatedMessage: "Your post was updated successfully.",
        },

      media: {
        previewAlt: "Preview",
      },

      addMusic: {
      back: "Back",
      heading: "🎵 Choose Music",
      searchPlaceholder: "Search title or artist…",
      clear: "Clear",
      noMatches: "No tracks match “{{query}}”.",
      openDetails: "Open details for {{title}}",
      choose: "Choose",
      chooseTitle: "Choose this track",
      noVideo: "No video selected",
      unknownTrack: "track",
    },

    report: {
  failed: "Failed to report post",
  button: "Report Post",
  title: "Report this post",
  detailsPlaceholder: "(Optional) Describe the issue...",
  submit: "Submit Report",
  submitted: "Report submitted",
  reasons: {
    spam: "Spam",
    hate: "Hate speech",
    harassment: "Harassment or bullying",
    sexualContent: "Sexual content",
    scamOrFraud: "Scam or fraud",
    violence: "Violence",
    selfHarm: "Self-harm",
    other: "Other",
  },
},

ad: {
  learnMore: "Learn more",
  sponsored: "Sponsored",
},

/////////////////////////////////////////////////////////////
// Gallery.Choose Track
/////////////////////////////////////////////////////////////

    chooseTrack: {
      selectTrack: "Select a track.",
      noVideoSource:
        "No HTTP video source and no File available. Re-open from Add Music so the video file is in memory, or provide a server URL.",
      previewFailed: "Preview failed. See console for details.",
      generatePreviewFirst: "Generate a preview first.",
      saveFailed: "Save failed. See console for details.",

      trimMusicTitle: "Trim music",
      unknownArtist: "Unknown artist",
      trackPreview: "Track preview",

      play: "Play",
      pause: "Pause",

      mergeCta: "Merge Music & Video",
      saveCta: "Save & Continue",

      processing: "Processing on server…",
      noVideo: "No video selected",
    },
    },

/////////////////////////////////////////////////////////////

    videoFilter: {
      sidebar: {
        title: "Filter",
      },
      buttons: {
        reset: "Reset",
        save: "Save",
        back: "Back",
        processing: "Processing…",
      },
      messages: {
        noMedia: "No media found for editing.",
        noSource: "No video source…",
        processFailed: "Failed to process the video. Check console for details.",
      },
      preview: {
        placeholderAria: "Video placeholder",
      },
      controls: {
        muted: "Muted",
        autoplay: "Autoplay",
      },
    },


/////////////////////////////////////////////////////////////
// Location Change
/////////////////////////////////////////////////////////////

    locationChange: {    
      unknown: "Unknown",
      title: "Change Location",
      sidebar: {
        title: "Change Location",
      },
      search: {
        placeholder: "Search a city or country…",
        clearAria: "Clear search",
        searching: "Searching…",
        noResults: "No results",
        ariaSuggestions: "Location suggestions",
      },
      badge: {    
        country: "Country",
        state: "State/Region",
        city: "City",
        village: "Village",
        suburb: "Suburb",
        place: "Place",
        popular: "Popular"   
      },
      popular: {
        title: "Quick suggestions",
      },

      actions: {
        useCurrentLocation: "Use Current Location",
        confirm: "Confirm Location",
        closeAria: "Close",

      },
      labels: {
        selected: "{{city}}, {{country}}",
        selectedLabel: "Selected",

      },
    },

    confirmLocation: {
      title: "Confirm your location",
      loading: "Loading map and location data...",
      locationKnown: "{{city}} ({{country}})",
      locationUnknown: "Location unknown",
      captionPlaceholder: "Write a caption (optional)…",
      buttons: {
        confirmAndPost: "Confirm Location & Post",
        posting: "Posting…",
      },
      alerts: {
        missingMediaOrLocation: "Missing media or location. Please check and try again.",
        loginRequired: "You need to log in.",
        postSuccess: "Your post was published successfully!",
        postFailed: "Failed to post. Please try again.",
      },
    },     

    //MediaPresentaionMode
    mediaPresentation: {
      loading: 'Loading...',
      empty: 'No media to show.',
    },
    

    //Edit Media
    editMedia: {
      title: "Edit Media",
      noItem: "No media item selected for editing.",
      save: "Save",
      alt: "Edit Media",
    },  

//MediaPreviewMode
    mediaPreview: {
      empty: "No preview media found.",
      viewer: {
        closeLabel: "Close viewer",
        closeTitle: "Close",
        prevLabel: "Previous",
        prevTitle: "Previous",
        nextLabel: "Next",
        nextTitle: "Next",
      },
    },
    
    //MediaViewerOverlay
    mediaViewer: {
      closeLabel: "Close",
      prevLabel: "Previous",
      nextLabel: "Next",
    },

    imageFilter: {
      sidebar: {
        title: "Filter",
      },
      buttons: {
        reset: "Reset",
        save: "Save",
        back: "Back",
      },
      messages: {
        noMedia: "No media found for editing.",
        loading: "Loading…",
      },
    },

    posts: {
      create: {
        mediaReady: "Media attached and ready to save.",
        save: "Save",
      },
    },


    //MusicDetailPage
musicDetail: {
  loading: "Loading…",
  notFound: "Track not found.",
  loadError: "Failed to load track details.",
  back: "Back",
  close: "Close",
  unknownArtist: "Unknown artist",
  coverAlt: "Cover",

  usedIn_one: "Used in {{count}} post",
  usedIn_other: "Used in {{count}} posts",

  empty: "No videos/images found using this track yet.",

  openPostTitle: "Open post",
  openPostLabel: "Open →",
},
 


    //LocationCollection
  locationCollection: {
  title: "Location posts",
  unknownCity: "Unknown city",
  unknownCountry: "Unknown country",
  empty: "No posts found for this location yet.",
  loadError: "Failed to load location posts.",
  openPostLabel: "Open →",
  posts_one: "{{count}} post",
  posts_other: "{{count}} posts",
},

       
    //PresentationPreview
    presentationPreview: {
      noMedia: "No preview media found.",
      closeViewer: "Close viewer",
      previous: "Previous",
      next: "Next",
    },
    //SmartVideoPlayer
    smartVideo: {
      playWithSound: "Play with sound",
      html5Fallback: "Your browser does not support HTML5 video.",
    },

    //BlockedList
    blockedList: {
      title: "Blocked Users",
      refresh: "Refresh",
      refreshing: "Refreshing…",
  
      loading: "Loading…",
      empty: "You haven’t blocked anyone yet.",
  
      errorLoad: "Failed to load blocked users.",
      errorUnblock: "Failed to unblock.",
  
      confirmUnblock: "Unblock this user?",
  
      statusDeleted: "deleted",
      statusDeactivated: "deactivated",
  
      blockedSince: "Blocked since:",
      viewProfile: "View profile",
  
      unblocking: "Unblocking…",
      unblock: "Unblock",
    },

    // FollowButtonInline
    followButton: {
      follow: "Follow",
      unfollow: "Unfollow",
    },      

    //Hashtag Selector
    hashtagSelector: {
      placeholder: "Type or choose hidden hashtags",
      placeholdermobile: "Type hidden hashtags",
    },
  
    // Language Selector
    languageSelector: {
      title: "Select Your Language",
      close: "Close",
    },
  //Lazymedia
    lazymedia: {
      videoNotSupported: "Your browser does not support the video tag.",
    },

    //Mediauploader
    mediaUploader: {
      uploading: "Uploading…",
      uploadFailed: "Upload failed",
      uploadedLabel: "Uploaded:",
      openFile: "open file",
    },
    

    //FirstRunPrivacy
    firstRunPrivacy: {
      title: "Let’s set your privacy basics",
      loading: "Loading…",
      errorSave: "Could not save preferences.",
      yes: "Yes",
      no: "No",
      continue: "Continue",
      saving: "Saving…",
      footerNote: "You can change these anytime in Settings → Data & Privacy.",
      toggles: {
        locationTitle: "Use device location",
        locationDesc: "Use my device location when I tag a post or explore nearby.",
        analyticsTitle: "Anonymous analytics",
        analyticsDesc: "Help us improve features in aggregate. No ads, no trackers.",
        pushTitle: "Push notifications",
        pushDesc: "Allow app notifications for messages and activity.",
      },
    },

    requirePrivacyChange: {
      title: "For posting, location usage needs to be activated",
      close: "Close",
      errorSave: "Could not save preferences.",
    },

    requirePrivacyChangeCL: {
      title: "To use current location, location access needs to be enabled",
      close: "Close",
      errorSave: "Could not save preferences.",
    },

    requirePrivacyChangeMap: {
      title: "To use current location on the map, location access needs to be enabled",
      close: "Close",
      cancel: "Cancel",
      errorSave: "Could not save preferences.",
    },

  profileActions: {
    moreActions: "More actions",

    postsNamed: "{{name}}'s posts",
    postsGeneric: "View posts",
    thisUser: "this user",

    follow: "Follow",
    unfollow: "Unfollow",

    block: "Block",
    unblock: "Unblock",
    blockAndReport: "Block & report",

    blockConfirm:
      "Block {{name}}? They won't be able to interact with you, and you won't see each other’s posts or messages.",

    blocked: "User blocked.",
    unblocked: "User unblocked.",
    blockedWithInfo:
      "User blocked. You can report them from the Report screen later.",

    errors: {
      actionFailed: "Action failed",
      blockFailed: "Block failed",
      unblockFailed: "Unblock failed",
    },
  },

  openMenu: {
    title: "Menu",
    gallery: "🖼 Gallery",
    favorite: "⭐ My Feed",
    myLikes: "❤️ My Likes",
    locationChange: "🌍 Change Location",
    uploadPost: "📷 Upload Post",
    notifications: "🔔 Notifications",
    myProfile: "👻 My Profile",
    myPosts: "📭 My Posts",
    chat: "💬 Chat",
    settings: "⚙️ Settings",
    logout: "🚪 Logout",
},

  
  //Countries
  ...countries,
  
  //Settings
  ...settings,

  //Sidebars
  ...sidebars,

  //Chat
  ...chat,

  //MyProfile
  ...myProfile,

  //Privacy Terms
  ...termsOfUse,

//Data Protection Report
  ...privacyPolicy,

  ...accountSupport,
 ...platformGuide,
...advertisementGuide,
...faq,
  //Home
  home,

  

  help,

  //Ad
  ad,

  

    // 🔗 Email-confirm status messages
    confirmEmailLoading: "⏳ Confirming your email...",
    confirmEmailSuccess: "🎉 Your email has been confirmed! Redirecting...",
    confirmEmailError: "❌ Invalid or expired confirmation link.",
  
    emailConfirmedTitle: "✅ Email confirmed successfully!",
    emailConfirmedRedirect: "Redirecting to your profile...",
    emailConfirmedFailed: "❌ Confirmation failed",
    emailConfirmedMissingToken: "Missing or invalid confirmation token.",
    emailConfirmedChecking: "Verifying your confirmation link...",
  } as const;
  
  export default en;
  